export const pipeReducers = <T>(state: T, ...pipe: ((state: T) => T)[]) =>
  pipe.reduce((intermediateState, reduce) => reduce(intermediateState), state);

export const partialPayload =
  <T, K extends any[]>(
    reducer: (state: T, ...payload: K) => T,
    ...payload: K
  ) =>
  (state: T) =>
    reducer(state, ...payload);
